import { useParams } from "react-router";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { Textblocks } from "@/services/backend/textblocks/components/textblocks";
import { useVbsCalculationShowQuery } from "@/services/backend/vbs/calculations/api/calculation-api";
import { GSMSubdomain } from "@/shared/types/gsm-subdomain";
import { GSMDocumentKind } from "@/services/backend/documents/types/kind";
import t from "@/lang/lang";
import { TreatmentRemark } from "@/services/backend/vbs/treatments/components/treatment-remark";

export function TextblocksRoute() {
  const { calculationId } = useParams();
  const { data, isLoading, error } = useVbsCalculationShowQuery({
    id: calculationId!,
  });

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  if (isLoading) {
    return null;
  }

  return (
    <div className="grid gap-2">
      <TreatmentRemark treatmentId={data!.treatmentId} />
      <Textblocks
        title={t("Allgemeine Bemerkungen")}
        subdomain={GSMSubdomain.VBS}
        documentKind={GSMDocumentKind.Treatment}
        documentId={data!.treatmentId}
      />
    </div>
  );
}
